<div
	class="breadcrumb-new"
	[ngClass]="{ 'without-links-mobile-size': !showLinksBreadMobileSize }"
>
	<div class="container-new">
		<div class="title-download">
			<div class="title">
				@if(backUrl){
				<button
					class="btn-just-icon btn-back btn-tc btn-tertiary-new size-sm"
					(click)="back()"
					appMousePress
					[disableRipple]="true"
					mat-flat-button
				>
					<i class="ico-arrow-narrow-right"></i>
				</button>
				}
				<span class="txt">
					{{
						titlePage
							? ("BREAD_CRUMB." + titlePage | translate)
							: ("BREAD_CRUMB." + breadcrumbs[0].label
							  | translate)
					}}
				</span>

				@if(chatPageUrl){
				<a
					[routerLink]="chatPageUrl"
					(click)="saveLinkToStorage()"
					class="link-chat"
				>
					<i class="fal fa-message-lines"></i>
				</a>
				}
			</div>
			<div class="buttons-page-header">
				@if (video) {
				<tc-video-guide
					[url]="video.url"
					[poster]="video.poster"
					[isButton]="true"
				/>
				} @if(!isNativePlatform){ @if(hasDownload &&
				showDowloadAppMobileSize){
				<a
					type="button"
					(click)="getAndroinAppLink()"
					mat-stroked-button
					[disableRipple]="true"
					appMousePress
					class="download-btn btn-tc size-md btn-secondary-new"
				>
					<img src="./assets/media/images/new-design/android.svg" />
					{{ "GENERAL.DOWNLOAD_APP" | translate }}
				</a>
				} }

				<tc-new-button
					class="guide-btn"
					[btnType]="'button'"
					[attributeVariantsType]="attributeVariantsType.Flat"
					[hierarchyType]="hierarchyType.Secondary"
					[sizeType]="sizeType.MD"
					[hasOneIcon]="true"
					[isJustIcon]="isMobile"
					[isRound]="true"
					(clickBtn)="guiedLink()"
				>
					<ng-container dataBtn>
						<i class="ico-help-circle"></i>
						@if(!isMobile){
						{{ "GENERAL.GUIDE" | translate }}
						}
					</ng-container>
				</tc-new-button>
			</div>
		</div>
		@if(withBread){ @if(breadcrumbs[0].label !=='DASHBOARD'){
		@if(showLinksBreadMobileSize){
		<div class="route">
			<ul>
				<li routerLink="/dashboard">
					<span class="home-page">
						<i class="ico-bar-chart-square-02"></i>
					</span>
					<i class="arrow-bread ico-chevron-left"></i>
				</li>
				@for (breadcrumb of breadcrumbs; track $index; let last = $last)
				{
				<li>
					@if(!last){ @if(breadcrumb.url){
					<a [routerLink]="[breadcrumb.url]">
						<span>
							{{ "BREAD_CRUMB." + breadcrumb.label | translate }}
						</span>
						@if(!last){
						<i class="arrow-bread ico-chevron-left"></i>
						}
					</a>
					}@else{
					<a>
						<span>
							{{ "BREAD_CRUMB." + breadcrumb.label | translate }}
						</span>
						@if(!last){
						<i class="arrow-bread ico-chevron-left"></i>
						}
					</a>
					} } @if(last){
					<label class="bread">{{
						"BREAD_CRUMB." + breadcrumb.label | translate
					}}</label>
					}
				</li>
				}
			</ul>
		</div>
		} } }
	</div>
</div>
